import { render, staticRenderFns } from "./search-result.vue?vue&type=template&id=407ab968&scoped=true&"
import script from "./search-result.vue?vue&type=script&lang=js&"
export * from "./search-result.vue?vue&type=script&lang=js&"
import style0 from "./search-result.vue?vue&type=style&index=0&id=407ab968&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ab968",
  null
  
)

export default component.exports